/**
 * @author       Yannick Deubel (https://github.com/yandeu)
 * @copyright    Copyright (c) 2021 Yannick Deubel; Project Url: https://github.com/enable3d/enable3d
 * @license      {@link https://github.com/enable3d/enable3d/blob/master/LICENSE|GNU GPLv3}
 */
import { SpriteSheet } from './spriteSheet';
export class Button extends SpriteSheet {
    constructor(texture, frameOptions, overFrame, outFrame, downFrame) {
        super(texture, frameOptions);
        this.overFrame = overFrame;
        this.outFrame = outFrame;
        this.downFrame = downFrame;
        this.setFrame(outFrame);
    }
    _onInputOver() {
        this.setFrame(this.overFrame);
    }
    _onInputOut() {
        this.setFrame(this.outFrame);
    }
    _onInputDown() {
        this.setFrame(this.downFrame);
    }
}
//# sourceMappingURL=button.js.map